import { computed, ref } from 'vue'
import {
  hasBlockedVehicle,
  hasInactiveDriver
} from '@/modules/road-maintenance-module/winter-service-v2/requests/composables/requestData'

/**
 * Whether the request on screen has a vehicle or a driver that can no longer take it.
 *
 * The field list is built before the request is fetched, and the fields have to be able
 * to carry the red frame the design puts around whichever of the two is the problem - so
 * the answer is kept here, written by the details block once the record lands and read
 * back by the field list. Module level, because the two live in separate trees and there
 * is only ever one request details screen open.
 */
const record = ref(null)

export function useRequestAbnormality () {
  const setRecord = (value) => {
    record.value = value || null
  }

  const isVehicleBlocked = computed(() => hasBlockedVehicle(record.value))
  const isDriverInactive = computed(() => hasInactiveDriver(record.value))

  return {
    setRecord,
    isVehicleBlocked,
    isDriverInactive
  }
}
